"use client"

import React, { PropsWithChildren, useEffect, useState } from 'react'
import { CHAT_ITEM_LIST } from '../constants/content';
import { ChatItemProps } from '../types';

type ActiveChatContextType = {
    activeChat: ChatItemProps | null,
    setActiveChat: React.Dispatch<React.SetStateAction<ChatItemProps | null>>,
    showChatDetails: boolean,
    handleShowChatDetails: (showDetails: boolean) => void
}


const ActiveChatContext = React.createContext<ActiveChatContextType | null>(null);

/**
 * Active Chat Context Provider, 
 * used to manage the active chat and chat details visibility
 */
export const ActiveChatProvider = ({ children }: PropsWithChildren) => {

    const [activeChat, setActiveChat] = React.useState<ChatItemProps | null>(CHAT_ITEM_LIST[0]);

    const [showChatDetails, setShowChatDetails] = useState(false);

    const handleShowChatDetails = (showDetails: boolean) => {
        const screenWidth = window.innerWidth;
        if (screenWidth <= 1024) {
            setShowChatDetails(showDetails)
        }
    }

    const handleResize = () => {
        const screenWidth = window.innerWidth;
        if (screenWidth >= 1024) {
            setShowChatDetails(false)
        }
    }

    useEffect(() => {
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <ActiveChatContext.Provider
            value={{
                activeChat,
                setActiveChat,
                showChatDetails,
                handleShowChatDetails
            }}
        >
            {children}
        </ActiveChatContext.Provider>
    );
};

export const useActiveChat = () => {
    const context = React.useContext(ActiveChatContext);
    if (!context) {
        throw new Error('useActiveChat must be used within an ActiveChatProvider');
    }
    return context;
};


export default ActiveChatContext